import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { openCguPdf, openPrivacyPolicyPdf, publicLogoPath, publicSvgPath } from '@orientaction/utils';
import RedesignImage from '../components/RedesignImage';
import {
  FOOTER_CONTACT_URL,
  FOOTER_EUROPE_TEXT,
  FOOTER_PHONE,
  FOOTER_QUALIOPI_TEXT,
  FOOTER_SERVICES,
} from './constants';
import { useFooterStyles } from './Footer.styles';

const SERVICES_COLUMN_SPLIT = 5;

const Footer = () => {
  const classes = useFooterStyles();
  const currentYear = new Date().getFullYear();
  const servicesColumnOne = FOOTER_SERVICES.slice(0, SERVICES_COLUMN_SPLIT);
  const servicesColumnTwo = FOOTER_SERVICES.slice(SERVICES_COLUMN_SPLIT);

  return (
    <footer className={classes.root}>
      <div className={classes.inner}>
        <div className={classes.topSection}>
          <div className={classes.contactColumn}>
            <div className={classes.contactText}>
              <p>Besoin d&apos;un échange personnalisé ?</p>
              <div className={classes.contactPhone}>
                <p>{FOOTER_PHONE}</p>
                <p>(numéro national non surtaxé)</p>
              </div>
            </div>
            <a
              href={FOOTER_CONTACT_URL}
              target="_blank"
              rel="noreferrer"
              className={classes.contactButton}>
              <MailOutlineIcon className={classes.contactButtonIcon} aria-hidden="true" />
              Nous contacter
            </a>
          </div>

          <div className={classes.servicesColumn}>
            <h2 className={classes.servicesTitle}>Nos services</h2>
            <div className={classes.servicesGrid}>
              <div className={classes.servicesList}>
                {servicesColumnOne.map(({ label, href }) => (
                  <a
                    key={href}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.serviceLink}>
                    {label}
                  </a>
                ))}
              </div>
              <div className={classes.servicesList}>
                {servicesColumnTwo.map(({ label, href }) => (
                  <a
                    key={href}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.serviceLink}>
                    {label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className={classes.divider} />

      <div className={`${classes.inner} ${classes.certificationsSection}`}>
        <div className={classes.certificationsLeft}>
          <div className={classes.logosRow}>
            <RedesignImage
              src={`${publicSvgPath}/qualiopi.png`}
              alt="Certification Qualiopi"
              className={classes.qualiopiLogo}
            />
            <RedesignImage
              src={`${publicSvgPath}/europe.png`}
              alt="Sélection européenne innovation sociale 2009"
              className={classes.europeLogo}
            />
          </div>
          <p className={classes.certificationText}>
            {FOOTER_QUALIOPI_TEXT}
            {'\n\n'}
            {FOOTER_EUROPE_TEXT}
          </p>
        </div>

        <div className={classes.brandColumn}>
          <RedesignImage
            src={`${publicLogoPath}/e-orientaction-redesign.png`}
            alt="E-ORIENTACTION"
            className={classes.brandLogo}
          />
          <p className={classes.brandTagline}>
            Votre plateforme digitale pour construire
            <br />
            une trajectoire alignée et durable.
          </p>
        </div>
      </div>

      <hr className={classes.divider} />

      <div className={classes.bottomBar}>
        <p className={classes.copyright}>© ORIENTACTION® {currentYear}</p>
        <div className={classes.legalLinks}>
          <button type="button" onClick={openCguPdf} className={classes.legalLink}>
            Conditions Générales d&apos;Utilisation
          </button>
          <span className={classes.legalSeparator} aria-hidden="true">
            |
          </span>
          <button type="button" onClick={openPrivacyPolicyPdf} className={classes.legalLink}>
            Politique de confidentialité
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
